module.exports = __webpack_public_path__ + "assets/retail.36215205.svg";